export default {
    getModule: state => state.module,
    getClient: state => uuid => state.module.find(client => client.uuid === uuid),
}